import React from 'react';

import * as FieldType from './FieldConstants';
import Input from './Field/Input';
import List from './Field/List';
import Textarea from './Field/Textarea';
import Checkbox from './Field/Checkbox';
import UserDetailsProvider from './Field/Provider/UserDetailsProvider';

/**
 * Field builder.
 *
 * @param {Object} props configs of filed
 */
const typeMap = {
  [FieldType.USER_DETAILS_PROVIDER]: UserDetailsProvider,
  [FieldType.TEXTAREA_FIELD]: Textarea,
  [FieldType.LIST_FIELD]: List,
  [FieldType.CHECKBOX_FIELD]: Checkbox
};

const FieldBuilder = props => {
  const Field = typeMap[props.type] || Input;
  return <Field {...props} />;
};

export default FieldBuilder;
